const SvgArrowLeftRight = (props) => (
  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3193_26592)">
      <path d="M12.25 6.41667V1.75H7.58333L9.5025 3.66917L3.66917 9.5025L1.75 7.58333V12.25H6.41667L4.4975 10.3308L10.3308 4.4975L12.25 6.41667Z" />
    </g>
    <defs>
      <clipPath id="clip0_3193_26592">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg >
);

export default SvgArrowLeftRight;
